import * as React from "react";
import { useSlideEditStore } from "@/state/slideEditStore";
import SlideEditMainContent from "./components/SlideEditMainContent";
import { SlideEditSidebar } from "./components/SlideEditSidebar";

const SlideEditContainer: React.FC = () => {
  const { showSidebar } = useSlideEditStore();

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        gap: "1rem",
        minHeight: "100vh",
      }}
    >
      {showSidebar && <SlideEditSidebar />}
      <div style={{ width: showSidebar ? "80%" : "100%", marginLeft: showSidebar ? "auto" : 0 }}>
        <SlideEditMainContent />
      </div>
    </div>
  );
};

export default SlideEditContainer;
